// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__34LYH","insightsList":"newBusinessInsightsMenu_insightsList__ELRSm","active":"newBusinessInsightsMenu_active__23iWK"};